<template>
  <div class="box">
    <div class="content">
      <div class="card">
        <div class="title-box">
          <!-- <van-icon name="arrow-left" class="icon-arrow" /> -->
          <span>{{ activityData.activityTitle }}</span>
          <!-- <van-icon name="arrow" class="icon-arrow" /> -->
        </div>
        <div class="time-box">
          <span class="title">距离活动结束</span>
          <van-count-down :time="countDownTime">
            <template #default="timeData">
              <div class="countdown-content">
                <span class="block">{{ timeData.days }}</span>
                <span class="space">天</span>
                <span class="block">{{ timeData.hours }}</span>
                <span class="space">时</span>
                <span class="block">{{ timeData.minutes }}</span>
                <span class="space">分</span>
                <span class="block">{{ timeData.seconds }}</span>
                <span class="space">秒</span>
              </div>
            </template>
          </van-count-down>
        </div>
        <div class="money-box">
          <template v-if="activityData.signUpfee > 0">
            <div class="money">
              <div class="symbol-left">
                <span class="rmb">¥</span>
                <span class="title-sign">{{activityData.signUpfeeLabel}}</span>
              </div>
              <span class="number" :style="{fontSize: (activityData.signUpfee.toString().length >= 6 ? '40px' : '')}">{{activityData.signUpfee || 0}}</span>
            </div>
          </template>
          <template v-else>
            <div class="money">
              <span class="number mf">免费</span>
            </div>
          </template>
          <div class="btn">抢</div>
        </div>
        <div class="browse">
          <div class="browse-item">
            <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/CF/rB8LrWUuQmaAal6eAAAHdq6jvtE759.png" alt="" />
            <span class="text">已浏览</span>
            <span class="number">{{signUpData.browsePeopleNumber}}</span>人
          </div>
          <div class="browse-item">
            <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/D0/rB8LrmUuTwCAU-_wAAAGAja_ywc394.png" alt="" />
            <span class="text">已参加</span>
            <span class="number">{{signUpData.signUpNumber}}</span>人
          </div>
        </div>
        <div class="notice-box" v-if="activityData.boolShowNotice">
          <van-notice-bar left-icon="volume-o" :scrollable="false">
            <van-swipe
              vertical
              class="notice-swipe"
              :autoplay="3000"
              :show-indicators="false"
            >
              <van-swipe-item v-for="item in signUpData.signUpList" :key="item.userPhone">
                刚刚{{item.joinUserName | joinUserName }}已成功参与活动
              </van-swipe-item>
            </van-swipe>
          </van-notice-bar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import signUpMixin from './signUpMixin'
export default {
 mixins: [signUpMixin]
}
</script>

<style lang="stylus" scoped>
  .box {
    .content {
      overflow hidden;
      width: 100%;
      height: 411px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/A1/rB8LrmU3oiaAVP5-AANWFM2ygb4550.png');
      background-size: 100% 100%;
      .card {
        overflow hidden;
        width: 100%;
        height: 100%;
        .title-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 320px;
          height: 40px;
          margin: auto;
          margin-top: 87px;
          font-size: 20px;
          font-weight: 800;
          color: #E24409;
          text-align: center;
          .icon-arrow {
            font-size: 12px;
            color: #D22E02;
            font-weight: bold;
            opacity: 0.4;
          }
          span {
            margin: 0 10px;
          }
        }
        .time-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 14px;
          .title {
            // width: 100px;
            font-size: 14px;
            font-weight: 600;
            color: #6B2F1A;
          }
          .countdown-content {
            margin-top: 15px;
            .block {
              display: inline-block;
              width: 39px;
              height: 39px;
              text-align: center;
              line-height: 39px;
              color: #E24409;
              font-size: 20px;
              font-weight: 600;
              border: 1px solid #E24409;
              opacity: 0.5;
              border-radius: 5px;
              background: #FCE6D2;
            }
            .space {
              font-size: 14px;
              color: #6B2F1A;
              margin: 0 6px;
            }
          }
        }
        .money-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 320px;
          height: 91px;
          margin-top: 15px;
          margin-left: 31px;
          background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/CD/rB8LrmUuOi-AA-U4AAAhTYkUPl4350.png');
          background-size: 100% 100%;
          overflow hidden
          .money{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 210px;
            height: 100%;
            font-weight: bold;
            color: #FFEBC0;
            text-shadow: 0px 2px 1px #FFEBC0;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            .symbol-left {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 74px;
              .rmb {
                font-size: 18px;
              }
              .title-sign {
                font-size: 10px;
                writing-mode: tb-rl;
                margin-right: 2px;
              }
            }
            .number {
              line-height: 60px;
              text-align: center;
              font-size: 75px;
              margin-bottom: 4px;
            }
            .mf {
              font-size: 65px;
              margin-top: -4px;
            }
          }
          .btn {
            width: 64px;
            height: 66px;
            color: #FFF99B;
            font-size: 32px;
            font-weight: 600;
            text-align: center;
            line-height: 50px;
            margin: 10px 8px 0 0;
            background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/D1/rB8LrWUuT7uAGANOAABB9JXQRT8290.png');
            background-size: 100% 100%;
            text-shadow: 0px 4px 2px #D16029;
          }
        }
        .browse {
          display: flex;
          justify-content: space-around;
          width: 320px;
          margin: auto;
          margin-top: 4px;
          .browse-item {
            display: flex;
            align-items: center;
            color: #6B2F1A;
            font-size: 13px;
            img {
              width: 19px;
              height: 19px;
            }
            .text {
              margin: 0 6px;
            }
            .number {
              color: #F33900;
              margin-right: 6px;
            }
          }
        }
        .notice-box {
          width: 305px;
          height: 24px;
          background: #FF8D3F;
          box-shadow: 0px 0px 3px 1px rgba(168,37,0,0.6);
          border-radius: 5px;
          margin: auto;
          margin-top: 14px;
          >>> .van-notice-bar {
            height: 24px;
            color: #FFFFFF;
            font-size: 9px;
            background: transparent;
          }
          .notice-swipe {
            height: 24px;
            line-height: 24px;
          }
        } 
      }
    }
  }
</style>